import psHttp from '@patsnap/common-ps-http';
import { coreBasicApiUrlPrefix, chemicalExternalApiPrefix } from '../../config/constants';

/*
 chemical 跳转SAVE_QUERY
*/
export const saveQuery = (data = {}) => {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/web-query`,
        method: 'POST',
        data,
        headers: {
            'X-API-Version': '1.0'
        }
    });
};

/*
 chemical  获取跳转的url
*/
export const transferLocation = (data = {}) => {
    return psHttp({
        url: `${chemicalExternalApiPrefix}/transfer/analytics`,
        method: 'POST',
        data
    });
};

export const chemicalTransferQueryApi = (data = {}) => {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/query/transform`,
        method: 'POST',
        data,
        headers: {
            'X-API-Version': '1.0'
        }
    }).then(({ data }) => {
        return data;
    });
};

// 获取服务器时间戳(毫秒)
export const getServiceTimeStamp = () => {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/security/timestamp`,
        method: 'GET',
    }).then(({ data }) => {
        return data.data;
    });
}
